module.exports = "<div class=\"q-section feed-row-item\"> <div class=q-marg-horz-md> <div class=\"q-tc-container q-min-height-65 q-pad-vert-xxs q-marg-vert-md-at-md\"> <div class=\"q-tc-row q-v-align-children-middle\"> {%= rowColumns %} </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/globalHtml/rowTemplate.html
// module id = 1137
// module chunks = 1